module.exports = __webpack_public_path__ + "static/media/iphone 11 banner1.d244b099.jpg";